import { render, staticRenderFns } from "./_filter_list_from_params.vue?vue&type=template&id=8c63afb2&scoped=true&"
import script from "./_filter_list_from_params.vue?vue&type=script&lang=js&"
export * from "./_filter_list_from_params.vue?vue&type=script&lang=js&"
import style0 from "./_filter_list_from_params.vue?vue&type=style&index=0&id=8c63afb2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c63afb2",
  null
  
)

export default component.exports